import { render, staticRenderFns } from "./domesticCourierSelectModal.vue?vue&type=template&id=5759c24d&scoped=true"
import script from "./domesticCourierSelectModal.vue?vue&type=script&lang=js"
export * from "./domesticCourierSelectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5759c24d",
  null
  
)

export default component.exports